import React from 'react'
import { makeStyles } from '@material-ui/core'
import Typography from '../Typography'
import Card from '@material-ui/core/Card'
import moment from 'moment-timezone'
import classnames from 'classnames'
import CheckCircle from '@material-ui/icons/CheckCircle'
import type { MessageActivity } from '@paintscout/api'
import { useUser } from '../../providers/UserProvider'

type DivProps = JSX.IntrinsicElements['div']

export interface ActivityFooterProps extends DivProps {
  activity?: MessageActivity
  timestamp: number
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      marginTop: 2,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
      color: theme.palette.grey[500],
      paddingRight: theme.spacing()
    },
    extendedTimeDiv: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    checkCircle: {
      fontSize: '1rem !important',
      marginLeft: theme.spacing(0.5)
    },
    popover: {
      padding: '0px 2px 0px 2px',
      position: 'absolute',
      left: '25px',
      top: '-20px',
      border: '1px solid #bbb',
      width: '65px',
      backgroundColor: '#fff'
    },
    checkHolder: {
      position: 'relative'
    },
    sentTime: {
      textTransform: 'none'
    }
  }),
  {
    name: 'ActivityFooter'
  }
)

export default function ActivityFooter({ activity, timestamp, children, ...props }: ActivityFooterProps) {
  const [isHovered, setIsHovered] = React.useState<boolean>(false)
  const classes = useStyles(props)
  const { user } = useUser()
  const sentTime = moment(timestamp).format('hh:mma')
  const hasBeenRead = activity?.details?.message.readAt ?? false
  const readTime = hasBeenRead ? moment(hasBeenRead).format('MMM D hh:mma') : 'Not read'

  const ExtendedTime = () => {
    return (
      <div
        onMouseLeave={() => {
          setIsHovered(false)
        }}
        className={classes.extendedTimeDiv}
      >
        <Typography className={classes.sentTime} variant={'overline'}>
          {sentTime}
        </Typography>
        {hasBeenRead && user && (
          <div className={classes.checkHolder}>
            <CheckCircle
              onMouseEnter={() => {
                setIsHovered(true)
              }}
              onMouseLeave={() => {
                setIsHovered(false)
              }}
              className={classes.checkCircle}
            />
            <Card className={classes.popover} hidden={!isHovered}>
              <Typography variant="body2">Read:</Typography>
              <Typography variant="body2">{readTime}</Typography>
            </Card>
          </div>
        )}
      </div>
    )
  }

  return (
    <div {...props} className={classnames(classes.root, props.className)}>
      <ExtendedTime />
      {children}
    </div>
  )
}
